/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/ContractPdf";

export function addContract(data) {
  return APIClient.post(`${endpoint}`, data);
}

export function getContract() {
  return APIClient.get(`${endpoint}`);
}
export function getContractById(id) {
  return APIClient.get(`${endpoint}/id/${id}`);
}

export function getContractByType(value) {
  return APIClient.post(`${endpoint}/filter`, value);
}

export function editContract(data, id) {
  return APIClient.put(`${endpoint}/${id}`, data);
}
export function deleteContract(id) {
  return APIClient.delete(`${endpoint}/${id}`);
}
